<template>
  <div class="pedidos-andamento">
    <g-card class="card-pedidos-andamento" 
    margem="20px" 
    :expansivel="true" 
    :comecaFechado="false">
      <template #cabecalho>
        <div class="header-filtros">
          <div class="titulo-filtros-cabecalho"> Pedidos em Fase De Digitação </div>
          <div class="header-icons">
            <g-button
            class="trash-box"
            tipo="cinza"
            altura="35px"
            largura="45px"
            icone="icone_lixo.svg"
            tamanhoIcone="15px"
            somenteIcone
            :sombreado="false"
            v-tooltip="'Limpar filtro'"
            @click="clear"
            />
            <g-button
            class="buscar-button-header-filtro"
            largura="150px"
            icone="icone_lupa.svg"
            negritoTexto
            tamanhoIcone="15px"
            tamanhoTexto="15px"
            altura="35px"
            gap="10px"
            :sombreado="false"
            @click="buscar"
            >
              BUSCAR
            </g-button>
          </div>
        </div>
      </template>

      <g-form>
        <div class="pedidos-andamento-conteudo espacamento-filtros">
          <div class="unidade">
            <div class="unidade-titulo titulo-conteudo-filtros"> Unidade </div>
            <PDropDown
            class="unidade-input input-label unidade"
            placeholder="TODAS"
            :filter="true"
            :options="ArrayUnidade"
            optionLabel="nome"
            optionValue="id"
            v-model="PedidoAndamento.Unidade"
            />
          </div>

          <div class="representante">
            <div class="cliente-titulo titulo-conteudo-filtros"> Cliente </div>
            <cliente-dropdown
              class="cliente-input input-label"
              v-model="PedidoAndamento.Cliente"
              @change="ativaClienteAgrupador"
              :representanteId="this.$store.state.representanteSelecionadoId"
              :empresaId="PedidoAndamento.Unidade"
            />
          </div>

          <div class="cliente">
            <div class="numero-solicitacao-titulo titulo-conteudo-filtros"> Nº da Solicitação </div>
            <PInputText
            class="numero-solicitacao-input input-label"
            placeholder="Insira o Nº da Solicitação"
            v-model="PedidoAndamento.NumeroDaSolicitacao"
            />
          </div>

          <div class="numero-solicitacao">
            <div class="numero-pedido-titulo titulo-conteudo-filtros"> Número do Pedido </div>
            <PInputText
            class="numero-pedido-input input-label"
            placeholder="Insira o Nº do Pedido"
            v-model="PedidoAndamento.NumeroPedido"
            />
          </div>

          <div class="numero-pedido">
            <div class="numero-parcela-titulo titulo-conteudo-filtros"> Nº da Parcela </div>
            <PInputText
            class="numero-parcela-input input-label"
            placeholder="Insira o Nº da Parcela"
            v-model="PedidoAndamento.NumeroParcela"
            />
          </div>

          <div class="numero-parcela">
            <div class="tipo-pedido-titulo titulo-conteudo-filtros"> Tipo do Pedido </div>
            <PDropDown
            class="tipo-pedido-input input-label"
            placeholder="Selecione"
            :options="tipoPedidoArray"
            optionLabel="text"
            optionValue="enum"
            v-model="PedidoAndamento.TipoPedido"
            >
            </PDropDown>
          </div>

          <div class="tipo-pedido">
            <div class="codigo-produto-titulo titulo-conteudo-filtros"> Produto </div>
            <PDropDown
            class="nome-produto-input input-label"
            placeholder="Insira o nome do produto"
            optionLabel="labelProduto"
            v-model="PedidoAndamento.NomeProduto"
            optionValue="produtoId"
            @filter="getProduto($event.value)"
            :options="ProdutoArray"
            :filter="true"
            />
          </div>

          <div class="nome-produto">
            <div class="produto-novo-titulo titulo-conteudo-filtros"> Produto Novo </div>
            <PDropDown
            class="produto-novo-input input-label"
            placeholder="Identifique um novo produto"
            v-model="PedidoAndamento.ProdutoNovo"
            :filterFields="['labelProduto']"
            :filter="true"
            optionLabel="labelProduto"
            optionValue="produtoId"
            :options="OrcamentoProdutoArray"
            emptyMessage="Pesquise o produto desejado"
              @filter="buscarProdutoNovo($event.value)"
            />
          </div>

          <div class="produto-novo">
            <div class="indicador-pedido-titulo titulo-conteudo-filtros"> Status do Pedido </div>
            <PDropDown
                class="status-pedido-input input-label unidade"
                placeholder="TODOS"
                v-model="PedidoAndamento.Status"
                :options="StatusArray"
                optionLabel="text"
                optionValue="value"
              />
          </div>

          <div class="indicador-pedido">
            <div class="data-entrega-titulo titulo-conteudo-filtros"> Data de Entrega </div>
            <div class="input-data">
              <div class="data-inicio">
                <g-date-input
                class="data-entrega-inicio-input input-label"
                placeholderinput="Início"
                alturainput="45px"
                largurainput="100%"
                tamanhobotao="35px"
                invertido
                v-model="PedidoAndamento.PeriodoEntregaInicio"
                :dataPassadas="true"
                ></g-date-input>
              </div>
              <div class="data-periodo"> à </div>
              <div class="data-termino">
                <g-date-input
                class="data-entrega-termino-input input-label"
                placeholderinput="Término"
                alturainput="45px"
                largurainput="100%"
                tamanhobotao="35px"
                v-model="PedidoAndamento.PeriodoEntregaFim"
                :dataPassadas="true"
                ></g-date-input>
              </div>
            </div>
          </div>

          <!-- <div class="data-entrega">
            <div class="data-carregamento-titulo titulo-conteudo-filtros"> Data de Carregamento </div>
            <div class="input-data">
              <div class="data-inicio">
                <g-date-input
                class="data-carregamento-inicio-input input-label"
                placeholderinput="Início"
                alturainput="45px"
                largurainput="100%"
                tamanhobotao="35px"
                invertido
                v-model="PedidoAndamento.PeriodoCarregamentoInicio"
                :dataPassadas="true"
                ></g-date-input>
              </div>
              <div class="data-periodo"> à </div>
              <div class="data-termino">
                <g-date-input
                class="data-carregamento-termino-input input-label"
                placeholderinput="Término"
                alturainput="45px"
                largurainput="100%"
                tamanhobotao="35px"
                v-model="PedidoAndamento.PeriodoCarregamentoFim"
                :dataPassadas="true"
                ></g-date-input>
              </div>
            </div>
          </div> -->

          <div class="parametros">
            <div class="parametros-titulo titulo-conteudo-filtros"> Outros Parâmetros </div>
            <div class="parametros-checkboxes">
                <div class="consultar-dados checkbox">
                  <PCheckBox :binary="true" id="consultar-dados"  class="checkbox-consultas" v-model="PedidoAndamento.ConsultarDadosClienteAgrupador" :disabled="ClienteAgrupadorAtiva"></PCheckBox>
                  <label class="consultarDados label-checkbox" for="consultar-dados"> Consultar dados do cliente agrupador </label>
                </div>
            </div>
          </div>

          <div class="parametros">
          </div>
        </div>
      </g-form>

        <div class="buscar-button-filtro">
          <g-button
          class="buscar-button"
          largura="300px"
          icone="icone_lupa.svg"
          negritoTexto
          tamanhoIcone="15px"
          tamanhoTexto="15px"
          altura="35px"
          gap="10px"
          :sombreado="false"
          @click="buscar()"
          >
          BUSCAR
          </g-button>
        </div>
      </g-card>

      <g-card paddingDefault="0 0em 1em" :expansivel="false" :temCabecalho="false" class="card-resultado">
        <div v-if="mensagemvazio" class="">
          <img
            class="icone-global-imagemfundo"
            src="@/assets/imgs/Ilustracao_erro.svg"
          />
          <div class="texto-padrao-imagemfundo">
            Verifique os filtros e clique em buscar para exibir os resultados
          </div>
      </div>
      <div v-else-if="!mensagemvazio">
        <g-data-table
        TextoVazio="Nenhum Pedido Encontrado"
        Titulo="Pedidos em fase de digitação"
        altura="auto"
        :colunas="Colunas"
        :valores="PedidoArray"
        :numeroBotoesAcao="3"
        :NumeroLinhas="10"
        :ButtonStatus="true"
        :maxWidthExpansivel="'75px'"
        :NotaFiscal="listaNotaFiscal"
        :Imprimivel="false"
        TextNotaFiscal="Notas fiscais do pedido"
        v-on:clickImprimir="imprimir"
        v-on:OnNotaFiscal="notasFiscaisRota"
        @duploClickLinha="detalhesPedido"
        :campoAgrupador="'empresaCliente'"
        :campoExibicaoGrupo="'empresaCliente'"
        dataKey="pedidoParcela"
        TextImprimir="Abrir PDF"
        >
        <!-- <template #expansivel="slotProps">
            <g-data-table
              TextoVazio="Nenhum Componente Encontrado"
              Titulo="Componente"
              altura="auto"
              :valores="slotProps.linha.data.componentePedidoArray"
              :colunas="ColunasSubGridComponente"
              :NumeroLinhas="2"
              :Editavel= "false"
              :Imprimivel= "false"
              :rowEditor="false"
              :checkprancheta = "false"
              :esconderColunaFrozen = "true"
              :esconderHeader = "true"
              :FiltrosEspecificos = "false"
              :FiltroGeral = "false"
              :Paginacao="false"
              dataKey="PedidoParcelaComponenteId"
            >
            </g-data-table>
          </template> -->
      </g-data-table>
      </div>
    </g-card>
  </div>

  <g-pdf :pdfFloat="false" :NovaGuia="true" :executar="executarvisualizacao">
    <div class="render" v-if="renderiza">
      <PedidoEmAndamentoPDF :tituloDetalhes="false" v-on:termino="gerarPdf" :pedidoSelecionado="linhaSelecionada"></PedidoEmAndamentoPDF>
    </div>
  </g-pdf>
</template>

<script>
import PedidoEmAndamento from './PedidoEmAndamento.js'
export default PedidoEmAndamento
</script>

<style scoped>
.container-logo{
  padding: 30px 30px 10px 53px;
}
.titulo {
    color: #747474;
    text-align: left;
    font-family: Montserrat;
    font-weight: bold;
    padding: 5px 0;
}

.checkbox {
    display: flex;
    padding-top: 3px;
    padding-bottom: 3px;
}

.label-checkbox {
    color: #8A8A8A;
    text-align: left;
    font-size: 15px;
    font-family: 'MontSerrat';
    margin-left: 5px;
}

.codigo-nome-produto {
    width: 100%;
    display: grid;
    grid-template-columns: 30% minmax(6em, 1fr);
    grid-template-rows: auto;
    grid-column-gap: 20px;
    align-items: flex-end;
}

:deep(.p-inputtext){
  width: 100%;
}


@media (min-width: 310px) {

.pedidos-andamento-conteudo {
    display: flex;
    flex-direction: column;
    margin: 20px 0;
}

.titulo {
    font-size: 14px;
}

.grupo-dados-produto{
        display: grid;
        grid-template-columns: repeat(1, minmax(4em, 1fr));
        grid-template-rows: repeat(7, auto);
        column-gap: 3%;
    }

    .grupo-dados-pedido{
        display: grid;
        grid-template-columns: repeat(1, minmax(4em, 1fr));
        grid-template-rows: repeat(14, auto);
        column-gap: 3%;
    }

    .dados-caracteristicas-pedido{
        display: grid;
        grid-template-columns: repeat(1, minmax(4em, 1fr));
        grid-template-rows: repeat(4, auto);
        column-gap: 3%;
    }
    .grupo-produtos{
        display: grid;
        grid-template-columns: repeat(1, minmax(4em, 1fr));
        grid-template-rows: repeat(6, auto);
        column-gap: 3%;
    }

.input-label {
    width: 100%;
}

.buscar-button-filtro {
  display: flex;
  justify-content: center;
  align-items: self-end;
}
}

@media (min-width: 368px) {
  .grupo-dados-produto{
        display: grid;
        grid-template-columns: repeat(1, minmax(4em, 1fr));
        grid-template-rows: repeat(7, auto);
        column-gap: 3%;
    }

    .grupo-dados-pedido{
        display: grid;
        grid-template-columns: repeat(2, minmax(4em, 1fr));
        grid-template-rows: repeat(7, auto);
        column-gap: 3%;
    }

    .dados-caracteristicas-pedido{
        display: grid;
        grid-template-columns: repeat(2, minmax(4em, 1fr));
        grid-template-rows: repeat(2, auto);
        column-gap: 3%;
    }
    .grupo-produtos{
        display: grid;
        grid-template-columns: repeat(1, minmax(4em, 1fr));
        grid-template-rows: repeat(6, auto);
        column-gap: 3%;
    }

    .topico  {
        display: grid;
        grid-template-columns: repeat(2, 1fr);
    }
}

@media (min-width: 600px) {
.pedidos-andamento-conteudo {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-template-rows: repeat(7, auto);
  grid-column-gap: 20px;
}

.grupo-dados-produto{
        display: grid;
        grid-template-columns: repeat(2, minmax(4em, 1fr));
        grid-template-rows: repeat(4, auto);
        column-gap: 3%;
    }

    .grupo-dados-pedido{
        display: grid;
        grid-template-columns: repeat(2, minmax(4em, 1fr));
        grid-template-rows: repeat(7, auto);
        column-gap: 3%;
    }

    .dados-caracteristicas-pedido{
        display: grid;
        grid-template-columns: repeat(2, minmax(4em, 1fr));
        grid-template-rows: repeat(2, auto);
        column-gap: 3%;
    }
    .grupo-produtos{
        display: grid;
        grid-template-columns: repeat(2, minmax(4em, 1fr));
        grid-template-rows: repeat(3, auto);
        column-gap: 3%;
    }

    .topico  {
        display: grid;
        grid-template-columns: repeat(3, 1fr);
    }

.unidade { grid-area: 1 / 1 / 2 / 2; }
.representante { grid-area: 1 / 2 / 2 / 3; }
.cliente { grid-area: 2 / 1 / 3 / 3; }
.numero-solicitacao { grid-area: 3 / 1 / 4 / 2; }
.numero-pedido { grid-area: 3 / 2 / 4 / 3; }
.numero-parcela { grid-area: 4 / 1 / 5 / 2; }
.tipo-pedido { grid-area: 4 / 2 / 5 / 3; }
.codigo-nome-produto { grid-area: 5 / 1 / 6 / 2; }
.produto-novo { grid-area: 5 / 2 / 6 / 3; }
.indicador-pedido { grid-area: 6 / 1 / 7 / 2; }
.data-entrega { grid-area: 6 / 2 / 7 / 3; }
.data-carregamento { grid-area: 7 / 1 / 8 / 2; }
.parametros { grid-area: 6 / 2 / 7 / 3; }

.buscar-button-filtro {
  display: none;
}
}

@media (min-width: 801px) {
.parametros-checkboxes {
    display: flex;
    flex-wrap: wrap;
    column-gap: 20px;
}

.grupo-dados-produto{
        display: grid;
        grid-template-columns: repeat(4, minmax(4em, 1fr));
        grid-template-rows: repeat(2, auto);
        column-gap: 3%;
    }

    .grupo-dados-pedido{
        display: grid;
        grid-template-columns: repeat(4, minmax(4em, 1fr));
        grid-template-rows: repeat(4, auto);
        column-gap: 3%;
    }

    .dados-caracteristicas-pedido{
        display: grid;
        grid-template-columns: repeat(4, minmax(4em, 1fr));
        grid-template-rows: repeat(1, auto);
        column-gap: 3%;
    }
    .grupo-produtos{
        display: grid;
        grid-template-columns: repeat(4, minmax(4em, 1fr));
        grid-template-rows: repeat(2, auto);
        column-gap: 3%;
    }
    .conteudo-card-detalhes-pedido-andamento {
        padding: 0 30px;
    }

.pedidos-andamento-conteudo {
    margin: 20px 20px 0 20px;
}

.cliente { grid-area: 2 / 1 / 3 / 2; }
.numero-solicitacao { grid-area: 2 / 2 / 3 / 3; }
.numero-pedido { grid-area: 3 / 1 / 4 / 2; }
.numero-parcela { grid-area: 3 / 2 / 4 / 3; }
.tipo-pedido { grid-area: 4 / 1 / 5 / 2; }
.codigo-nome-produto { grid-area: 4 / 2 / 5 / 3; }
.produto-novo { grid-area: 5 / 1 / 6 / 2; }
.indicador-pedido { grid-area: 5 / 2 / 6 / 3; }
.data-entrega { grid-area: 6 / 1 / 7 / 2; }
.data-carregamento { grid-area: 6 / 2 / 7 / 3; }
.parametros { grid-area: 6 / 1 / 7 / 2; }
}

@media (min-width: 1025px) {
.pedidos-andamento-conteudo {
  grid-template-columns: repeat(3, 1fr);
  grid-template-rows: repeat(5, auto);
}

.conteudo-card-detalhes-pedido-andamento {
        padding: 0 50px;
    }
    .grupo-dados-produto{
        display: grid;
        grid-template-columns: repeat(4, minmax(4em, 1fr));
        grid-template-rows: repeat(2, auto);
        column-gap: 3%;
    }

    .grupo-dados-pedido{
        display: grid;
        grid-template-columns: repeat(4, minmax(4em, 1fr));
        grid-template-rows: repeat(4, auto);
        column-gap: 3%;
    }

    .dados-caracteristicas-pedido{
        display: grid;
        grid-template-columns: repeat(4, minmax(4em, 1fr));
        grid-template-rows: repeat(1, auto);
        column-gap: 3%;
    }
    .grupo-produtos{
        display: grid;
        grid-template-columns: repeat(4, minmax(4em, 1fr));
        grid-template-rows: repeat(2, auto);
        column-gap: 3%;
    }
    .topico  {
        display: grid;
        grid-template-columns: repeat(6, 1fr);
    }

.cliente { grid-area: 1 / 3 / 2 / 4; }
.numero-solicitacao { grid-area: 2 / 1 / 3 / 2; }
.numero-pedido { grid-area: 2 / 2 / 3 / 3; }
.numero-parcela { grid-area: 2 / 3 / 3 / 4; }
.tipo-pedido { grid-area: 3 / 1 / 4 / 2; }
.codigo-nome-produto { grid-area: 3 / 2 / 4 / 3; }
.produto-novo { grid-area: 3 / 3 / 4 / 4; }
.indicador-pedido { grid-area: 4 / 1 / 5 / 2; }
.data-entrega { grid-area: 4 / 2 / 5 / 3; }
.data-carregamento { grid-area: 4 / 3 / 5 / 4; }
.parametros { grid-area: 4 / 2 / 5 / 3; }
}

@media(min-width:1285px) {
    .grupo-dados-produto{
        display: grid;
        grid-template-columns: repeat(5, minmax(4em, 1fr));
        grid-template-rows: repeat(2, auto);
        column-gap: 3%;
    }

    .grupo-dados-pedido{
        display: grid;
        grid-template-columns: repeat(5, minmax(4em, 1fr));
        grid-template-rows: repeat(4, auto);
        column-gap: 3%;
    }

    .dados-caracteristicas-pedido{
        display: grid;
        grid-template-columns: repeat(5, minmax(4em, 1fr));
        grid-template-rows: repeat(1, auto);
        column-gap: 3%;
    }
    .grupo-produtos{
        display: grid;
        grid-template-columns: repeat(5, minmax(4em, 1fr));
        grid-template-rows: repeat(2, auto);
        column-gap: 3%;
    }
}

@media (min-width: 1600px) {
.pedidos-andamento-conteudo {
  grid-template-columns: repeat(4, 1fr);
  grid-template-rows: repeat(4, auto);
}

.numero-solicitacao { grid-area: 1 / 4 / 2 / 5; }
.numero-pedido { grid-area: 2 / 1 / 3 / 2; }
.numero-parcela { grid-area: 2 / 2 / 3 / 3; }
.tipo-pedido { grid-area: 2 / 3 / 3 / 4; }
.codigo-nome-produto { grid-area: 2 / 4 / 3 / 5; }
.produto-novo { grid-area: 3 / 1 / 4 / 2; }
.indicador-pedido { grid-area: 3 / 2 / 4 / 3; }
.data-entrega { grid-area: 3 / 3 / 4 / 4; }
.data-carregamento { grid-area: 3 / 4 / 4 / 5; }
.parametros { grid-area: 3 / 3 / 4 / 4; }
}

@media (min-width: 1500px) {
}
</style>